import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import {
  productFields,
  productWeightField,
  productWeightUnitField,
} from './common/productFields';
import { msg } from '@lingui/core/macro';
import { genericQuantityField, genericUnitField } from './common/sharedFields';

export const consumerGoodsTextileProductManufacturingMetadata = {
  displayName: msg({
    message: 'Textile product manufacturing',
    context: 'Activity data schema name for textile product manufacturing',
  }),
  fields: {
    ...coreFields,
    ...productFields,
    product_weight: productWeightField,
    product_weight_unit: productWeightUnitField,
    quantity: {
      ...genericQuantityField,
      externalDescription: msg({
        message: 'The quantity of product orders',
        context: 'Quantity',
      }),
    },
    tier_2_to_tier_1_supplier_distance_quantity: {
      displayName: msg({
        message: 'Tier 2 to tier 1 supplier distance',
        context: 'The distance from tier 2 supplier to tier 1 supplier',
      }),
    },
    tier_2_to_tier_1_supplier_distance_unit: {
      displayName: msg({
        message: 'Tier 2 to tier 1 supplier distance unit',
        context:
          'The unit of the distance from tier 2 supplier to tier 1 supplier',
      }),
    },
    tier_2_to_tier_1_supplier_transportation_mode: {
      displayName: msg({
        message: 'Tier 2 to tier 1 supplier transportation mode',
        context:
          'The mode of transportation used for tier 2 to tier 1 supplier',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
